import React from "react";
import "./TeamcenterRAC.css";
import TeamcenterRACOverview from "./TeamcenterRACOverview";
import BannerImage from "../../../assets/other_image/transition.jpg";
import Letsgetintouch from "../BusinessProcessAndChangeManagement/Letsgetintouch";
import { NavLink } from "react-router-dom";
import Banner from "../Banner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";

const TeamcenterRAC = () => {
  return (
    <section className="TeamcenterRAC-management">
    <Banner
        image={BannerImage} // Pass the image for this page
        heading=" Teamcenter RAC to Active Workspace Client Transition" // Pass the heading text for this page
      />
      <div>
         <FloatingContactUs />
      </div>


      <TeamcenterRACOverview />
      <section style={{ background: "#f5f7fa" }}>
        <div className="benefits container">
          <h4 className="TeamcenterRAC-page-heading">Unlock the Power :</h4>
          <h5 className="TeamcenterRAC-subheading">
            Discover the Transformative Benefits of Teamcenter RAC to Active Workspace Client Transition with NexTech!
          </h5>
          <ul className="custom-bullets">
            <li>
              Reduced time and costs with seamless and faster migration of RAC
              client usage to Active Workspace.{" "}
            </li>
            <li>
              Improved end-user productivity by mapping the business use cases
              with benchmark practices.{" "}
            </li>
            <li>
              Minimal/no customization to avoid code footprint in the new system
            </li>
            <li>Smooth user migration from RAC to AW client. </li>
          </ul>
        </div>
      </section>

      <section>
        <div className="solutions container">
          <div className="solutions-content">
            <div className="row">
              <div className="col-md-6 col-12">
                <h4 className="TeamcenterRAC-page-heading">Teamcenter Solutions</h4>

                <ul className="custom-bullets">
                  <li>
                    Tailored Strategy and Execution Plan: Crafted strategy and
                    precise execution plan for seamless transition from RAC to
                    Active Workspace, ensuring efficient migration.{" "}
                  </li>
                  <li>
                    Comprehensive Solution Development: Full-spectrum solution
                    development covering feature installation, configuration,
                    customization migration, and necessary development for a
                    smooth transition.{" "}
                  </li>
                  <li>
                    Business Use Case-Centric Training: Customized training
                    content and delivery for end-users, focusing on aligning
                    business use cases with best practices for enhanced
                    productivity.{" "}
                  </li>
                  <li>
                    Advanced Methodology: Adoption of advanced solutions and
                    methodologies like codeless customization and
                    de-customization to minimize code footprint and maximize
                    efficiency.{" "}
                  </li>
                  <li>
                    Reduced Time and Costs: Faster migration at reduced costs,
                    leveraging tools, and best practices for a streamlined
                    transition process.{" "}
                  </li>
                </ul>
              </div>

              <div className="col-md-6 col-12">
                <div className="quick-links">
                  <h4>Quick Links</h4>
                  <ul>
                    <li>
                      <NavLink
                        to={"/teamcenter/manufacturing-data-process-management"}
                      >
                        Manufacturing Data and Process Management
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to={"/teamcenter/plm-erp-data-process-management"}
                      >
                        PLM - ERP (SAP, Oracle, HANA) Data and Process
                        Management
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        to={"/teamcenter/product-bom-variability-management"}
                      >
                        Product BOM and Variability Management
                      </NavLink>
                    </li>

                    <li>
                      <NavLink to={"/teamcenter/community-collaboration"}>
                        Teamcenter Community Collaboration
                      </NavLink>
                    </li>

                    <li>
                      <NavLink to={"/teamcenter/cybersecurity"}>
                        Teamcenter Cyber Security
                      </NavLink>
                    </li>

                    <li>
                      <NavLink to={"/teamcenter/cloud-implementation"}>
                        Teamcenter Implementation on Cloud
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/implementation"}>
                        Teamcenter Implementation
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section style={{ background: "#f5f7fa" }}>
        <div className="why-nextech container">
          <h4 className="TeamcenterRAC-page-heading">Why NexTech?</h4>
          <h5 className="TeamcenterRAC-subheading">
            For Teamcenter RAC to Active Workspace Client Transition{" "}
          </h5>
          <ul className="custom-bullets">
            <li>
              Faster migration at reduced costs leveraging advanced
              methodologies.
            </li>
            <li>Ensured smooth migration from RAC to AW client for users.</li>
            <li>
              Improved end-user productivity through business use case
              alignment.
            </li>
            <li>
              Adoption of advanced solutions like codeless customization and
              de-customization to minimize code footprint and maximize
              efficiency.
            </li>
          </ul>
        </div>
      </section>
      <Letsgetintouch />
    </section>
  );
};

export default TeamcenterRAC;
